import React from 'react'
import { Box, Button, Icon, Tooltip } from '@node-space/ui-components'
import { LoadingIndicator } from 'components/LoadingIndicator'
import { parseNumericValue } from '../../utils/utils'

export interface EarnEmbeddedLabelValueRowProps {
  testId: string
  label: string
  value: React.ReactNode
  labelVariant?: 'default' | 'emphasis'
  valueVariant?: 'default' | 'success'
  isLoading?: boolean
  tooltipContent?: string
}

const labelClassNames: Record<
  NonNullable<EarnEmbeddedLabelValueRowProps['labelVariant']>,
  string
> = {
  default: 'text-body-regular text-foreground-subdued',
  emphasis: 'text-label text-foreground-prominent',
}

const valueClassNames: Record<
  NonNullable<EarnEmbeddedLabelValueRowProps['valueVariant']>,
  string
> = {
  default: 'text-h3 text-foreground-prominent',
  success: 'text-h3 text-accent-status-success',
}

export const EarnEmbeddedLabelValueRow = ({
  testId,
  label,
  value,
  labelVariant = 'default',
  valueVariant = 'default',
  isLoading,
  tooltipContent,
}: EarnEmbeddedLabelValueRowProps) => {
  const numericValue = parseNumericValue(value)
  const resolvedValueVariant =
    valueVariant === 'success' && numericValue !== null && numericValue <= 0
      ? 'default'
      : valueVariant

  let valueElement =
    typeof value === 'string' ? (
      <h3 className={valueClassNames[resolvedValueVariant]}>{value}</h3>
    ) : (
      value
    )
  if (isLoading) {
    valueElement = <LoadingIndicator testId={`${testId}-skeleton`} />
  }

  const labelElement = <p className={labelClassNames[labelVariant]}>{label}</p>

  return (
    <Box flex justify="between" align="center" testId={testId}>
      {tooltipContent ? (
        <Box flex gap={8} align="center">
          {labelElement}
          <Tooltip bodyContent={tooltipContent} type="complex" position="bottom">
            <Button variant="ghost" noPadding iconElement={<Icon name="Info" />} />
          </Tooltip>
        </Box>
      ) : (
        labelElement
      )}
      {valueElement}
    </Box>
  )
}
